<template>
  <v-container fluid class="webConDoc-management mt-4 px-1">
    <v-row>

      <template>
        <v-row justify="center">
          <v-dialog
              v-model="dialog_upload"
              width="1250px"
          >
            <v-card>

              <UploadManagement
                  id="Conpage_UploadManagement">

              </UploadManagement>

            </v-card>


          </v-dialog>
        </v-row>
      </template>


      <v-col cols="12">
        <v-card class="mb-1" v-if="state=='index'">


          <v-card-title class="pa-5 pb-3">
            <p>การจัดการข้อมูล MOU</p><span
              class="grey--text font-weight-regular subtitle-2 pt-1">{{ '\xa0 (' + webConDocs.length }} รายการ) </span>
            <v-spacer></v-spacer>
            <div>

              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="4">

                  <v-select
                      @change="searchData"
                      @blur="changeDocGroup('s')"
                      v-model="search_data.doc_group_tag"
                      :items="doc_group_combo"
                      item-text="parameter_th"
                      item-value="parameter_value"
                      label="ประเภทเอกสาร"
                      clearable=""
                  ></v-select>


                </v-col>


                <v-col class="d-flex" cols="12" sm="4">

                  <v-select
                      @change="searchData"
                      v-model="search_data.doc_type_tag"
                      :items="doc_type_combo"
                      item-text="parameter_th"
                      item-value="parameter_value"
                      label="ส่วนแสดงผล"
                      clearable=""
                  ></v-select>


                </v-col>

                <v-col class="d-flex" cols="12" sm="4">
                  <v-text-field
                      append-icon="mdi-magnify"
                      class="search"
                      v-model="search"
                      label="ค้นหา (Search)"
                  ></v-text-field>
                </v-col>

              </v-row>


              <!--              <v-text-field
                                v-model="search"
                                append-icon="mdi-magnify"
                                label="ค้นหา (Search)"
                                single-line
                                hide-details
                                class="search"
                            ></v-text-field>-->
            </div>
          </v-card-title>

          <v-card-text class="px-5">
            <v-data-table
                :loading="isReceiving || isDeleting"
                loading-text="Loading... Please wait"
                class="product-table"
                show-select
                :headers="headers"
                :items-per-page="15"
                :footer-props="{
                'items-per-page-options': [5, 10, 15, 50,-1]
                }"
                :items="webConDocs"
                :search="search"
                :options="options">
              <template v-slot:top>


                <template>
                  <v-btn
                      color="success"
                      dark
                      class="my-4 button-shadow"
                      @click="addItem()"
                  >เพิ่มรายการใหม่
                  </v-btn>
                </template>


              </template>

              <template v-slot:item.doc_h_file="{ item }">

                <v-avatar tile v-if="item.status_link =='Y'">
                  <img
                      :src="baseURLStorage+'/icon_extensions/'+'File_Share.svg'"
                      :alt="item.doc_title_th"
                  >
                </v-avatar>
                <v-avatar tile v-else>
                  <img
                      :src="baseURLStorage+'/icon_extensions/'+'File_Cloud.svg'"
                      :alt="item.doc_title_th"
                  >
                </v-avatar>

              </template>


              <template v-slot:item.switch_lang="{ item }">
                <v-btn
                    fab
                    x-small
                    depressed
                    color=""
                >TH
                </v-btn>
                <v-btn v-if="item.switch_lang=='Y'"
                       fab
                       x-small
                       depressed
                       color=""
                >EN
                </v-btn>

              </template>

              <template v-slot:item.doc_title_th="{ item }">
                <a :href="baseURLStorage+item.doc_h_file" target="_blank" v-if="item.status_link =='Y'">
                  <span>{{ item.doc_title_th }}</span> <sup>{{ item.doc_content_th }}</sup>
                </a>

                <a :href="item.doc_h_url" target="_blank" v-else>
                  <span>{{ item.doc_title_th }}</span> <sup>{{ item.doc_content_th }}</sup>
                </a>


              </template>


              <template v-slot:item.active="{ item }">
                <span v-if="item.active == 'Y'" class="v-chip theme--light v-size--small success"><span
                    class="v-chip__content">ใช้งาน</span></span>
                <span v-else class="v-chip theme--light v-size--small "><span
                    class="v-chip__content">ยกเลิก</span></span>

                <span v-if="item.expire == 'Y'" class="v-chip theme--light v-size--small warning"><span
                    class="v-chip__content">หมดอายุ</span></span>


              </template>


              <template v-slot:item.api="{ item }">
                <v-btn
                    class="mr-3 button-shadow"
                    @click="editItem(item)"
                    small
                    color="success"
                >แก้ไข
                </v-btn>
                <v-btn
                    @click="deleteItem(item)"
                    small
                    class="button-shadow"
                    color="secondary"
                >ลบข้อมูล
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>


        </v-card>

        <v-card class="mb-1" v-if="state=='editForm' || state=='addForm'">

          <v-card-title class="pa-5 pb-3">
            <p>{{ formTitle }}</p>

          </v-card-title>


          <v-card-text class="pa-5 pt-0">
            <v-form
                ref="form"
                v-model="editForm.valid"
                lazy-validation>

              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="2">
                  <v-text-field
                      v-model="editForm.doc_id"
                      label="หมายเลขเอกสาร (ID)"
                      required
                      disabled
                  ></v-text-field>

                </v-col>
                <v-col class="d-flex" cols="12" sm="6">

                  <v-select
                      @change="changeDocGroup('e')"
                      v-model="editForm.doc_group_tag"
                      :rules="editForm.textReqRules"
                      :items="doc_group_combo"
                      item-text="parameter_th"
                      item-value="parameter_value"
                      label="ประเภทเอกสาร"
                      required
                      clearable=""
                  ></v-select>


                </v-col>


                <v-col class="d-flex" cols="12" sm="3">

                  <v-switch
                      v-model="editForm.switch_lang"
                      inset
                      true-value="Y"
                      false-value="N"
                      :rules="editForm.textReqRules"
                      label="เพิ่มเนื้อหาภาษา [EN]"
                      required
                  ></v-switch>


                </v-col>

              </v-row>

              <v-row align="center">
                <v-col class="d-flex" cols="12" sm="6">

                  <v-select
                      v-model="editForm.doc_type_tag"
                      :rules="editForm.multipleReqRules"
                      :items="doc_type_combo"
                      attach
                      chips
                      deletable-chips
                      item-text="parameter_th"
                      item-value="parameter_value"
                      label="ส่วนแสดงผล"
                      multiple
                      required
                  ></v-select>


                </v-col>


                <v-col class="d-flex" cols="6">


                  <v-combobox
                      v-model="editForm.doc_tag"
                      chips
                      clearable
                      label="เพิ่ม Tag/Keywords สามารถเลือกจากรายการ /หรือพิมพ์แล้วกด Enter"
                      multiple

                  >
                    <template v-slot:selection="{ attrs, item, select, selected }">
                      <v-chip
                          v-bind="attrs"
                          :input-value="selected"
                          close
                          @click="select"
                          @click:close="removeTag(item)"
                      >
                        <strong>{{ item }}</strong>
                      </v-chip>
                    </template>
                  </v-combobox>

                </v-col>
              </v-row>

              <v-row align="center">
                <v-col class="d-flex" cols="12" sm="4">
                  <v-text-field
                      v-model="editForm.doc_index"
                      :rules="editForm.textReqRules"
                      label="เลขที่"
                      hint="ตัวเลข หากไม่มี -"
                      persistent-hint
                      required
                  ></v-text-field>
                </v-col>
                <v-col class="d-flex" cols="12" sm="4">

                  <v-text-field
                      v-model="editForm.doc_year"
                      :rules="editForm.textReqRules.concat(editForm.numRules).concat(
                          [ v => v >= 2000 || 'ระบุปีเป็น พ.ศ. ต่ำสุดคือ 2000',
                            v => v <= 9999 || 'ระบุปีเป็น พ.ศ. สูงสุดคือ 9999',
                          ]
                      )"
                      label="ปี"
                      hint="ปี พ.ศ."
                      persistent-hint
                      required
                  ></v-text-field>
                </v-col>
                <v-col class="d-flex" cols="12" sm="4">


                  <v-menu
                      v-model="menu2"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          v-model="dateFormatted"
                          label="วันที่เอกสาร"
                          hint="วัน/เดือน/พ.ศ."
                          persistent-hint
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="date"
                        :first-day-of-week="1"
                        locale="th"
                        @input="menu2 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>


              </v-row>


              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="12">
                  <v-text-field
                      v-model="editForm.doc_title_th"
                      :rules="editForm.textReqRules"
                      label="ชื่อ MOU (TH)"
                      required
                  ></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" sm="12" v-if="editForm.switch_lang=='Y'">
                  <v-text-field
                      v-model="editForm.doc_title_en"
                      :rules="editForm.textReqRules"
                      label="ชื่อ MOU (EN)"
                      required
                  ></v-text-field>
                </v-col>

              </v-row>

              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="12">
                  <v-text-field
                      v-model="editForm.doc_content_th"
                      :rules="editForm.textReqRules"
                      label="ชื่อหน่วยงาน (TH)"
                      required
                  ></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" sm="12" v-if="editForm.switch_lang=='Y'">
                  <v-text-field
                      v-model="editForm.doc_content_en"
                      :rules="editForm.textReqRules"
                      label="ชื่อหน่วยงาน (EN)"
                      required
                  ></v-text-field>
                </v-col>

              </v-row>


              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="2">

                  <v-switch
                      v-model="editForm.status_link"
                      inset
                      true-value="Y"
                      false-value="N"
                      :rules="editForm.textReqRules"
                      label="อัพโหลดไฟล์ | URL"
                      required
                  ></v-switch>

                </v-col>

                <v-col class="d-flex" cols="12" sm="10" v-if="state=='addForm'">
                  <v-file-input
                      v-if="editForm.status_link=='Y'"
                      v-model="editForm.avatarFileFi"
                      show-size
                      chips
                      :rules="editForm.textReqRules.concat(editForm.fileRules)"
                      placeholder="อัพโหลดไฟล์"
                      prepend-icon="mdi-file"
                      label="อัพโหลดไฟล์"
                  ></v-file-input>

                  <v-text-field
                      v-if="editForm.status_link=='N'"
                      v-model="editForm.doc_h_url"
                      :rules="editForm.textReqRules"
                      label="URL ของไฟล์"
                      required
                  ></v-text-field>

                </v-col>
                <v-col class="d-flex" cols="12" sm="10" v-if="state=='editForm'">


                  <div class="text-center" v-if="editForm.status_link=='Y' && !editForm.avatarFileFiOld==false">
                    <v-chip
                        link
                        class="ma-4"
                        color="default"
                    >
                      <v-icon left>mdi-file</v-icon>
                      <a :href="baseURLStorage+editForm.avatarFileFiOld" target="_blank">
                        ไฟล์อัพโหลดเดิม </a>
                    </v-chip>
                  </div>


                  <v-file-input
                      v-if="editForm.status_link=='Y'"
                      v-model="editForm.avatarFileFi"
                      show-size
                      chips
                      :rules="editForm.fileRules"
                      placeholder="อัพโหลดไฟล์ใหม่"
                      prepend-icon="mdi-file"
                      label="อัพโหลดไฟล์ใหม่"
                  ></v-file-input>


                  <v-text-field
                      v-if="editForm.status_link=='N'"
                      v-model="editForm.doc_h_url"
                      :rules="editForm.textReqRules"
                      label="URL ของไฟล์"
                      required
                  ></v-text-field>

                </v-col>


              </v-row>


              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="2" v-if="state=='addForm'">

                  <v-col v-if="editForm.preview==''">

                    <v-row
                        class="fill-height"
                        align-content="center"
                        justify="center"
                    >
                      <v-col
                          class="text-subtitle-1 text-center"
                          cols="12"
                      >
                        เลือกไฟล์เพื่อแสดงผล
                      </v-col>
                      <v-col cols="6">
                        <v-progress-linear
                            color="deep-purple accent-4"
                            indeterminate
                            rounded
                            height="6"
                        ></v-progress-linear>
                      </v-col>
                    </v-row>

                  </v-col>
                  <v-col v-else>
                    <img v-bind:src="editForm.preview" style="max-width: 100%"/>
                  </v-col>


                </v-col>

                <v-col class="d-flex" cols="12" sm="4" v-if="state=='addForm'">

                  <v-file-input
                      @change="previewImage"
                      v-model="editForm.avatarFile"
                      show-size
                      chips
                      :rules="editForm.textReqRules.concat(editForm.imageRules)"
                      accept="image/*"
                      placeholder="ภาพประกอบ(ปก/อื่นๆ) (TH)"
                      prepend-icon="mdi-file-image"
                      label="ภาพประกอบ(ปก/อื่นๆ) (TH) "
                  ></v-file-input>


                </v-col>

                <v-col class="d-flex" cols="12" sm="2" v-if="state=='addForm' && editForm.switch_lang=='Y'">

                  <v-col v-if="editForm.preview_en==''">
                    <v-row
                        class="fill-height"
                        align-content="center"
                        justify="center"
                    >
                      <v-col
                          class="text-subtitle-1 text-center"
                          cols="12"
                      >
                        เลือกไฟล์เพื่อแสดงผล
                      </v-col>
                      <v-col cols="6">
                        <v-progress-linear
                            color="deep-purple accent-4"
                            indeterminate
                            rounded
                            height="6"
                        ></v-progress-linear>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col v-else>
                    <img v-bind:src="editForm.preview_en" style="max-width: 100%"/>
                  </v-col>


                </v-col>

                <v-col class="d-flex" cols="12" sm="4" v-if="state=='addForm' && editForm.switch_lang=='Y'">

                  <v-file-input
                      @change="previewImageEn"
                      v-model="editForm.avatarFileEn"
                      show-size
                      chips
                      :rules="editForm.textReqRules.concat(editForm.imageRules)"
                      accept="image/*"
                      placeholder="ภาพประกอบ(ปก/อื่นๆ) (EN)"
                      prepend-icon="mdi-file-image-plus"
                      label="ภาพประกอบ(ปก/อื่นๆ) (EN) "
                  ></v-file-input>


                </v-col>


                <!--*************************************************-->

                <v-col class="d-flex" cols="12" sm="2" v-if="state=='editForm'">

                  <v-col v-if="editForm.preview==''">

                    <v-img
                        :src="baseURLStorage+editForm.avatarFileOld"
                        :alt="editForm.doc_title_th"
                        style="max-width: 100%"
                    ></v-img>

                  </v-col>
                  <v-col v-else>
                    <img v-bind:src="editForm.preview" style="max-width: 100%"/>
                  </v-col>


                </v-col>

                <v-col class="d-flex" cols="12" sm="4" v-if="state=='editForm'">

                  <v-file-input
                      @change="previewImage"
                      v-model="editForm.avatarFile"
                      show-size
                      chips
                      :rules="editForm.imageRules"
                      accept="image/*"
                      placeholder="ภาพประกอบ(ปก/อื่นๆ)ใหม่ (TH)"
                      prepend-icon="mdi-file-image"
                      label="ภาพประกอบ(ปก/อื่นๆ)ใหม่ (TH) "
                  ></v-file-input>


                </v-col>

                <v-col class="d-flex" cols="12" sm="2" v-if="state=='editForm' && editForm.switch_lang=='Y'">

                  <v-col v-if="editForm.preview_en==''">
                    <v-img
                        :src="baseURLStorage+editForm.avatarFileEnOld"
                        :alt="editForm.doc_title_en"
                        style="max-width: 100%"
                    ></v-img>
                  </v-col>
                  <v-col v-else>
                    <img v-bind:src="editForm.preview_en" style="max-width: 100%"/>
                  </v-col>


                </v-col>

                <v-col class="d-flex" cols="12" sm="4" v-if="state=='editForm' && editForm.switch_lang=='Y'">

                  <v-file-input
                      @change="previewImageEn"
                      v-model="editForm.avatarFileEn"
                      show-size
                      chips
                      :rules="editForm.imageRules"
                      accept="image/*"
                      placeholder="ภาพประกอบ(ปก/อื่นๆ)ใหม่ (EN)"
                      prepend-icon="mdi-file-image-plus"
                      label="ภาพประกอบ(ปก/อื่นๆ)ใหม่ (EN) "
                  ></v-file-input>


                </v-col>

                <!--*************************************************-->


              </v-row>


              <v-row align="center">


                <v-col class="d-flex" cols="12" sm="2">

                  <v-switch
                      v-model="editForm.active"
                      inset
                      color="success"
                      true-value="Y"
                      false-value="N"
                      :rules="editForm.textReqRules"
                      label="ใช้งาน"
                      required
                  ></v-switch>


                </v-col>

                <v-col class="d-flex" cols="12" sm="2">

                  <v-switch
                      v-model="editForm.expire"
                      inset
                      color="secondary"
                      true-value="Y"
                      false-value="N"
                      :rules="editForm.textReqRules"
                      label="หมดอายุ/ยกเลิก"
                      required
                  ></v-switch>


                </v-col>

              </v-row>

              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="12">
                  <v-row justify="end">
                    <v-btn
                        color="secondary"
                        outlined
                        class="button-shadow mr-4"
                        @click="cancelForm">
                      ยกเลิก
                    </v-btn>
                    <v-btn
                        color="primary"
                        outlined
                        class="button-shadow mr-4"
                        @click="reset"
                        v-if="state=='addForm'">
                      ล้างข้อมูล
                    </v-btn>
                    <v-btn
                        :disabled="!editForm.valid"
                        color="primary"
                        class="button-shadow mr-4"
                        @click="validate">
                      บันทึก
                    </v-btn>
                  </v-row>

                </v-col>

              </v-row>

            </v-form>
          </v-card-text>


        </v-card>
      </v-col>
    </v-row>

    <v-snackbar
        v-model="snackbar"
        :color="color"
        right
        top
        style="top: 50px">
      <div v-html="text" class=""></div>
      <template v-slot:action="{ attrs }">
        <v-btn
            dark
            text
            v-bind="attrs"
            @click="snackbar = false">
          ปิด
        </v-btn>
      </template>
    </v-snackbar>

  </v-container>
</template>

<script>
import config from "@/config";
import {mapActions, mapState} from 'vuex';
import validateRules from '@/use/validateRules.js';
import Editor from '@tinymce/tinymce-vue';

import UploadManagement from '@/pages/WebContent/UploadManagement/UploadManagement';
import axios from "axios";

export default {
  name: 'ConDocMouManagement',
  data() {
    return {
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      dateFormatted: this.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
      modal: false,
      menu2: false,
      state: 'index',
      tiny: config.tiny,
      baseURLApi: config.baseURLApi,
      baseURLStorage: config.baseURLStorage,
      snackbar: null,
      dialog_upload: false,
      search: '',
      search_data: {
        doc_group_tag: "",
        doc_type_tag: "",
        doc_section: "MOU",
      },
      options: {
        sortBy: ['doc_id'],
        sortDesc: [true]
      },
      selected: [],
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'doc_id',
        },
        {
          text: 'ไฟล์เอกสาร', value: 'doc_h_file',
        },
        {text: 'ปี พ.ศ.', value: 'doc_year'},
        {text: 'หลายภาษา', value: 'switch_lang'},
        {text: 'ชื่อ MOU', value: 'doc_title_th'},

        {text: 'ใช้งาน', value: 'active'},
        {text: 'การจัดการ', value: 'api', sortable: false},
      ],

      doc_group_combo: [],
      doc_type_combo: [],
      detail_combo: [],
      notification: '<p class="font-weight-bold mb-0">หน้าเว็บพร้อมแล้วสำหรับการทำงาน - This page is ready',
      editedIndex: -1,
      editForm: {},
    }
  },
  components: {
    'editor': Editor, // <- Important part
    UploadManagement
  },
  computed: {
    // map state ใน Store ของเราเข้ามาเป็น Computed * เข้ามาเป็นตัวแปร
    // Method จะเรียก Function ทุกครั้งที่ Component re-render ใหม่ ซึ่งต่างจาก Computed จะไม่เรียก Function เมื่อ ข้อมูลไม่เปลี่ยน
    ...mapState('web_con_docs', ['webConDocs', "isReceiving", "isDeleting", "idToDelete", "webConDocMessage", "isUpdating", "errorMessage"]),
    formTitle() {
      return this.editedIndex === -1 ? 'เพิ่มรายการใหม่' : 'แก้ไขรายการ'
    },

    //Date Picker Format
    computedDateFormatted() {
      return this.formatDate(this.date)
    },

  },
  watch: {
    //Watched Property  คือ เฝ้าดูว่าข้อมูลในตัวแปลที่เรากําหนดมีการเปลี่ยนแปลงหรือไม่ ถ้ามีการเปลี่ยนแปลงก็จะรันคําสั่งที่เราเขียนไว้

    webConDocMessage() {

      if (this.webConDocMessage !== '') {
        this.notification = this.webConDocMessage

        if (this.errorMessage == true) {
          this.addErrorNotification();
        } else {
          this.addSuccessNotification();
        }
        this.close();
      }
    },

    //Date Picker Format
    date() {
      this.dateFormatted = this.formatDate(this.date)
    },
  },
  created() {
    this.addSuccessNotification();
  },
  mounted() {

    //ดึงฟังก์ชั่น จาก store
    this.getWebConDocsRequest(this.search_data);
    this.getDcParamCombobox();
    this.resetValue();
  },
  methods: {
    // mapAction() เป็น function สําหรับ map action ใน Store ของเราเข้ามาเป็น Methods
    ...mapActions('web_con_docs',
        [
          "getWebConDocsRequest",
          "deleteWebConDocRequest",
          "updateWebConDocRequest",
          "createWebConDocRequest"
        ]
    ),
    resetValue() {

      this.editForm = {
        valid: true,
        orderRules: validateRules.orderRules,
        numRules: validateRules.numRules,
        textReqRules: validateRules.textReqRules,
        multipleReqRules: validateRules.multipleReqRules,
        imageRules: validateRules.fileSingleRules(3),
        fileRules: validateRules.fileSingleRules(100),
        doc_index: '',
        doc_year: '',
        preview: '',
        preview_en: '',
        doc_id: null,
        doc_type_tag: '',
        doc_section: 'MOU',
        doc_group_tag: '',
        doc_tag: '',
        doc_tag_b: '',
        doc_title_th: '',
        doc_title_en: '',
        doc_content_th: '',
        doc_content_en: '',
        switch_lang: 'N',
        doct_date: '',
        status_link: 'Y',
        doc_ref: '',
        active: 'N',
        expire: 'N',
        avatarFile: null,
        avatarFileOld: null,
        avatarFileEn: null,
        avatarFileEnOld: null,
        avatarFileFi: null,
        avatarFileFiOld: null,
        doc_h_image_en: null,
        doc_h_image_th: null
      }
    },
    async getDcParamCombobox() {


      try {

        await axios.post(config.baseURLApi + '/combo_dc_param/' + 'WEB' + '/' + 'DOC_GROUP_MOU', '', {
          headers: {},
        }).then(res => {
          this.doc_group_combo = res.data;

          this.detail_combo = [];

          axios.post(config.baseURLApi + '/combo_dc_param_like/' + 'WEB' + '/' + 'DOC_MOU_TYPE_UNIT_', '', {
            headers: {},
          }).then(res2 => {

            if (res2.data.length > 0) {

              var objRes = (res2.data).reduce(function (r, a) {  //map key group
                r[a.parameter_name] = r[a.parameter_name] || [];
                r[a.parameter_name].push(a);
                return r;
              }, Object.create(null));

              for (var i in objRes) { // object to array key value
                // alert(i); // alerts key
                // alert(objRes[i]); //alerts key's value
                this.detail_combo.push({
                  v_key: i.replace("DOC_MOU_TYPE_UNIT_", ""),
                  v_value: objRes[i],
                })
              }

            }

          });


        });


      } catch (e) {
        this.showSnackbar(e);
      }


    },
    removeTag(item) {

      this.editForm.doc_tag.splice(this.editForm.doc_tag.indexOf(item), 1)
    },
    removeRef(item) {

      this.editForm.doc_ref.splice(this.editForm.doc_ref.indexOf(item), 1)
    },

    previewImage: function (event) {
      event == null ? this.editForm.preview = '' : this.editForm.preview = URL.createObjectURL(event)
    },
    previewImageEn: function (event) {
      event == null ? this.editForm.preview_en = '' : this.editForm.preview_en = URL.createObjectURL(event)
    },
    async addItem() {

      this.editedIndex = -1 //index = -1 add
      this.resetValue();
      this.editForm.doc_group_tag = 'D1';
      this.editForm.doc_section = 'MOU';
      await this.changeDocGroup('e');
      this.editForm.active = 'Y';
      this.editForm.expire = 'N';
      this.editForm.doc_index = '-'
      const [year] = this.date.split('-')
      this.editForm.doc_year = year * 1 + 543
      this.editForm.status_link = 'Y';
      this.editForm.doc_id = 'AUTO';
      this.editForm.doc_h_url = '#';
      this.state = 'addForm';

    },
    async editItem(item) {

      // check |null undefined 0 -0 NaN '' false| !X Xis variable return true if null !!x is notnull
      this.resetValue();
      this.editedIndex = this.webConDocs.indexOf(item) //index ของ row ที่จะแก้ไข
      this.editForm.doc_id = item.doc_id;
      this.editForm.doc_group_tag = item.doc_group_tag;
      this.editForm.doc_section = item.doc_section;
      await this.changeDocGroup('e');
      this.editForm.doc_type_tag = !item.doc_type_tag != true ? item.doc_type_tag.split(",") : '';
      this.editForm.doc_ref = !item.doc_ref != true ? item.doc_ref.split(",") : '';
      this.editForm.avatarFileOld = item.doc_h_image_th;
      this.editForm.avatarFileEnOld = item.doc_h_image_en;
      this.editForm.avatarFileFiOld = item.doc_h_file;

      this.editForm.doc_index = item.doc_index;
      this.editForm.doc_year = item.doc_year;

      this.editForm.doc_title_th = item.doc_title_th;
      this.editForm.doc_title_en = item.doc_title_en;
      this.editForm.status_link = item.status_link;
      this.editForm.doc_h_url = item.doc_h_url;
      this.editForm.doc_content_th = item.doc_content_th;
      this.editForm.doc_content_en = item.doc_content_en;
      this.editForm.doc_tag = !item.doc_tag != true ? item.doc_tag.split(",") : '';
      // this.editForm.doc_tag_b = !item.doc_tag_b != true ? item.doc_tag_b.split(",") : '';
      this.editForm.doc_tag_b = item.doc_tag_b;
      this.editForm.switch_lang = item.switch_lang;
      this.editForm.doct_date = item.doct_date;
      this.editForm.expire = item.expire;
      this.editForm.active = item.active;

      this.date = item.doct_date;
      this.dateFormatted = this.formatDate(item.doct_date);
      // this.editForm = Object.assign({}, item) //ถ้าใช้ validate not work!!
      this.state = 'editForm';

    },
    deleteItem(item) {

      confirm('ต้องการลบรายการนี้หรือไม่?') && this.deleteWebConDocRequest({doc_id: item.doc_id})

    },
    close() {

      if (this.errorMessage == false || this.webConDocMessage == '') {
        this.state = "index";
        this.editedIndex = -1
      }
    },
    save() {
      this.editForm.doct_date = this.date;


      if (this.editedIndex > -1) { //> -1 is แก้ไขรายการ else เพิ่มรายการใหม่
        !config.isBackend ?
            Object.assign(this.webConDocs[this.editedIndex], this.editForm)
            :
            this.updateWebConDocRequest(this.editForm)
      } else {
        !config.isBackend ?
            this.webConDocs.push(this.editForm)
            :
            this.createWebConDocRequest(this.editForm)
      }


    },
    addSuccessNotification() {
      this.snackbar = true;
      this.color = config.light.success;
      this.text = this.notification;

    },
    addErrorNotification() {
      this.snackbar = true;
      this.color = config.light.secondary;
      this.text = this.notification;
    },


    validate() {
      if (this.$refs.form.validate()) this.save()
    },

    reset() {
      this.$refs.form.reset()
    },
    cancelForm() {
      this.$refs.form.reset()
      // this.close()
      this.state = "index";
      this.editedIndex = -1
    },
    showUploads() {
      this.dialog_upload = true;
    },
    changeDocGroup(v_form) {
      var doc_group_tag = null;
      doc_group_tag = v_form == 'e' ? this.editForm.doc_group_tag : this.search_data.doc_group_tag;
      console.log(this.editForm)
      if (!doc_group_tag == false) { //flase is not nall
        this.editForm.doc_type_tag = null
        try {
          this.doc_type_combo = this.detail_combo.find(item => item.v_key === doc_group_tag).v_value
        } catch (e) {
          console.log(e)
          this.doc_type_combo = []
        }

      } else {
        this.editForm.doc_type_tag = null
        this.doc_type_combo = []
      }
    },

    //Date Picker Format

    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${(year) * 1 + 543}`
    },

    parseDate(date) {
      if (!date) return null
      const [month, day, year] = date.split('/')
      return `${(year) * 1 - 543}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    searchData() {
      this.getWebConDocsRequest(this.search_data);
    },

    async beforeMount() {
    },

  },
}
</script>

<style src="./ConDocMouManagement.scss" lang="scss"/>
